import React from 'react';
import { Column } from '@ant-design/charts';

interface ConfigData {
  aChart: any;
}

const ColumnChart: React.FC<ConfigData> = props => {
  
  return <Column {...props.aChart} />;
};

export default ColumnChart;